import { LAxios } from "../axios";
import { catchHandler } from "../catch-handler";
import { ErrorsOutput, RequestErrorInput, RequestOutput } from "./type";

export const requestsList = async (
  data?: RequestErrorInput,
): Promise<RequestOutput | string | undefined> => {
  try {
    const params = new URLSearchParams();
    params.append("date", data?.date || "");
    params.append("accountId", data?.accountId || "");
    params.append("userId", data?.userId || "");
    const queryString = params.toString();

    const response = await LAxios.get(`log/requests/?${queryString}`, {
      headers: {
        "x-include-skip": data?.skip,
        "x-include-limit": data?.limit,
      },
    });
    return response.data;
  } catch (error) {
    return catchHandler<RequestOutput | string | undefined>(
      error,
      data,
      requestsList,
      {},
    );
  }
};

export const errorsList = async (
  data?: RequestErrorInput,
): Promise<ErrorsOutput | string | undefined> => {
  try {
    const params = new URLSearchParams();
    params.append("date", data?.date || "");
    params.append("accountId", data?.accountId || "");
    params.append("userId", data?.userId || "");
    params.append("status", data?.status || "");
    const queryString = params.toString();

    const response = await LAxios.get(`log/errors/?${queryString}`, {
      headers: {
        "x-include-skip": data?.skip,
        "x-include-limit": data?.limit,
      },
    });
    return response.data;
  } catch (error) {
    return catchHandler<ErrorsOutput | string | undefined>(
      error,
      data,
      errorsList,
      {},
    );
  }
};
    
